<app-dashboard-layout>
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
  <div class="flex flex-column align-items-center" style="width: 100%; margin: 0px;">
    <div class="flex align-items-center justify-content-between w-full grid card">

      <div class="bg-container">
        <div class="container">

          <div class="lg:justify-content-start col-12 md:col-12 lg:col-6 pb-0 flex align-items-center justify-content-between">
            <div class="pl-3 pr-6" style="width: 150px; height: 68px;">
              <img src="../../../../assets/img/fruzty-logo.png"
                style="width: 150px; height: auto;" alt="fruzty-logo"/>
            </div>

            <button (click)="displaySidebar = true"
              class="btn-menu only-mobile inline lg:hidden" icon="pi pi-bars">
              <i class="pi pi-bars"></i>
            </button>

          </div>
          <div class="col-12 md:col-12 lg:col-6 hidden lg:block pb-0 justify-content-end align-content-center">
            <div class="flex flex-column md:flex-row align-items-center justify-content-end gap-1">
              <span class="pr-5 text-xl font-bold">PANEL ADMINISTRATIVO</span>

              <p-button (onClick)="goToNotifications()"
                styleClass="p-button-rounded p-button-secondary p-button-text" class="icon-button-size"
                pTooltip="Notificaciones" tooltipPosition="bottom">
                <span class="material-symbols-outlined header-icon-color">
                  notifications
                </span>
              </p-button>

              <p-button (onClick)="logout()" label="Cerrar sesión"
                icon="pi pi-fw pi-sign-out" styleClass="p-button-text p-button-primary p-button-sm" class="pr-2">
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-bg mt-8">
      <div class="container-sidebar only-desktop">
        <app-sidebar
          [showContainerUser]="true"
          [userCompleteName]="userCompleteName"
          [profileName]="'HomeHeader.AdminDashboard.AdminRoleName' | translate"
          [profileCompanyName]="''"
          [items]="items"
          [isAdmin]="true"
          (goToUserContactInfo)="goToUserContactInfo()"
        />
      </div>
      <div class="md:col-12 lg:col-10 lg:p-3 md:p-3 main-bg-color" [ngClass]="{'bg-color': hasGrayBg}">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div class="container-sidebar-mobile card flex">
    <p-sidebar [(visible)]="displaySidebar" [transitionOptions]="'1000ms'"
      [style]="{'width':'300px'}">

      <div class="container-welcome">
        <app-sidebar
          [showContainerUser]="false"
          [userCompleteName]="userCompleteName"
          [profileName]="'HomeHeader.AdminDashboard.AdminRoleName' | translate"
          [profileCompanyName]="''"
          [items]="items"
          [isAdmin]="true"
          (goToUserContactInfo)="goToUserContactInfo()"
        />
      </div>

      <ng-template pTemplate="footer">
        <div class="flex flex-column menu-items hidden lg:inline">
          <div (click)="onClickMenuOption('account')" onKeyPress=""
            class="flex flex-row menu-item" [ngClass]="{'menu-item-active': urlSegment === 'admin-user-panel'}">
            <span class="material-symbols-outlined menu-item-icon">
              account_circle
            </span>
            <span>{{'HomeHeader.UserMenu.AccountItem' | translate}}</span>
          </div>

          <div (click)="onClickMenuOption('logout')" onKeyPress=""
            class="flex flex-row menu-item">
            <span class="material-symbols-outlined menu-item-icon">
              login
            </span>
            <span>{{'HomeHeader.UserMenu.LogoutToolTip' | translate}}</span>
          </div>
        </div>
      </ng-template>

    </p-sidebar>
  </div>

</app-dashboard-layout>


